import React from "react";
import {Button, Checkbox, Col, Divider, Form, Input, Layout, Row} from "antd";
import './style.scss'
import logo1 from "../../../assets/img/logo1.png";
import undraw from "../../../assets/img/undraw.png";

const SignInPage = () => {


    return (
        <>

                <div className='welcome_screen'>

                    <Row gutter={8} className='main-row'>
                        <Col lg={12} sm={{span: 0}} hidden className='image-col'>
                            <div>
                                <img src={logo1} alt="logo" className='ndblogo'/>
                                <div className='undraw-img-div'>
                                    <img src={undraw} alt="logo"/>
                                </div>
                                <h1>WEALTH YOUR WEALTH</h1>
                                <h2>- No paperwork No stress - </h2>
                            </div>
                        </Col>
                        <Col lg={12} className='text-input-col'>
                            {/*<SignIn/>*/}
                            <h1>Hello Welcome back !</h1>
                            <Form
                                layout={"vertical"}
                                initialValues={{remember: true}}

                            >
                                <Row>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <Form.Item
                                            label="username"
                                            rules={[{required: true, message: 'Please input your Username!'}]}>
                                            <Input placeholder="Username"/>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <Form.Item
                                            label="password"
                                            rules={[{required: true, message: 'Please input your Password!'}]}
                                        >
                                            <Input
                                                type="password"
                                                placeholder="Password"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <Form.Item>
                                            <Form.Item name="remember" valuePropName="checked" noStyle>
                                                <Checkbox>Remember me</Checkbox>
                                            </Form.Item>

                                            <a className="login-form-forgot" style={{float: "right"}} href="">
                                                Forgot password
                                            </a>
                                        </Form.Item>

                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <Form.Item>
                                            <Button style={{width: '100%', backgroundColor: '#FF7400'}} type="primary"
                                                    htmlType="submit" className="login-form-button">
                                                Sign In
                                            </Button>
                                            <Divider type={"horizontal"}>OR</Divider>
                                            <div style={{textAlign: "center"}}>
                                                <p>New to your wealth?</p>
                                                <a href="">SIGN UP NOW!</a>
                                            </div>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </div>
        </>


    )

}
export default SignInPage;

